/******************************************************************************
 *
 * Copyright (c) 2017, the Perspective Authors.
 *
 * This file is part of the Perspective library, distributed under the terms of
 * the Apache License 2.0.  The full license can be found in the LICENSE file.
 *
 */
import * as d3 from "d3";
import {flattenArray} from "./flatten";
import minBandwidth from "./minBandwidth";
import withoutTicks from "./withoutTicks";

export const scale = () => withoutTicks(minBandwidth(d3.scaleBand()));

export const domain = () => {
    let valueNames = ["crossValue"];
    let orient = "horizontal";

    const _domain = (data) => {
        const flattenedData = flattenArray(data);
        return transformDomain([
            ...new Set(flattenedData.map((d) => d[valueNames[0]])),
        ]);
    };

    const transformDomain = (d) => (orient == "vertical" ? d.reverse() : d);

    _domain.valueName = (...args) => {
        if (!args.length) {
            return valueNames[0];
        }
        valueNames = [args[0]];
        return _domain;
    };
    _domain.valueNames = (...args) => {
        if (!args.length) {
            return valueNames;
        }
        valueNames = args[0];
        return _domain;
    };

    _domain.orient = (...args) => {
        if (!args.length) {
            return orient;
        }
        orient = args[0];
        return _domain;
    };

    return _domain;
};

export const labelFunction = (valueName) => (d) => d[valueName].join("|");
